import { useTranslate } from 'hooks/useTranslate';
import { FC } from 'react';
import { Modal } from 'react-bootstrap';
import { useSplitModal } from '../context/SplitModalContext';

const SplitModalHeader: FC = () => {
  const { t } = useTranslate();

  const { actions } = useSplitModal();

  return (
    <Modal.Header>
      <h5 className="modal-title">{t('Split')}&nbsp;</h5>
      <a className="close cursor-pointer" onClick={actions.handleCloseModal}>
        <em className="icon ni ni-cross" />
      </a>
    </Modal.Header>
  );
};

export default SplitModalHeader;
